import { useMemo } from 'react';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import {
  useListMethodsQuery,
  useListTypesQuery,
} from '../../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { CreateSigningAppointmentFormData } from './convertToCreateSigningAppointmentRequest';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { DisplayPropertyType } from '../../../../../ui-toolkit/orders/interfaces/ePropertyType';

interface ConfirmationValues {
  signingMethodValue: string;
  signingTypeValue: string;
  languageValue: string;
  propertyTypeValue: string;
  notaryValue: string;
  rateValue: string;
}

const getPropertyTypeValue = ({ transaction }: IOrderDetailsData): string => {
  if (!transaction.property_type) {
    return 'N/A';
  }
  return DisplayPropertyType[transaction.property_type];
};

export const useDeriveConfirmationValues = (
  { signingMethod, signingType, language, notary, rateCents }: CreateSigningAppointmentFormData,
  isDigitalSchedulingNotaryDraft?: boolean
): ConfirmationValues => {
  const { data: order } = useSelectCurrentOrder();
  const { signingMethodValue } = useListMethodsQuery(undefined, {
    selectFromResult: ({ data = [] }) => {
      return { signingMethodValue: data.find((methodResponse) => methodResponse.id === signingMethod)?.label ?? 'N/A' };
    },
  });
  const { signingTypeValue } = useListTypesQuery(undefined, {
    selectFromResult: ({ data = [] }) => {
      return { signingTypeValue: data.find((typeResponse) => typeResponse.id === signingType)?.label ?? 'N/A' };
    },
  });

  return useMemo(() => {
    const languageValue: string = language ?? ' N/A';
    const propertyTypeValue: string = getPropertyTypeValue(order);
    const notaryValue: string = isDigitalSchedulingNotaryDraft
      ? `To be added when assigned`
      : notary
        ? `${notary.firstName ?? ''} ${notary.lastName ?? ''}`
        : 'N/A';

    const rateValue: string = rateCents ? `$${rateCents / 100} / hour` : 'N/A';
    return {
      signingMethodValue,
      signingTypeValue,
      languageValue,
      propertyTypeValue,
      notaryValue,
      rateValue,
    };
  }, [language, order, isDigitalSchedulingNotaryDraft, notary, rateCents, signingMethodValue, signingTypeValue]);
};
